
import { useMfaEnrollmentOperations } from './useMfaEnrollmentOperations';
import { useMfaEnrollmentVerification } from './useMfaEnrollmentVerification';
import { useMfaUnenrollment } from './useMfaUnenrollment';

/**
 * Main MFA enrollment hook that combines all enrollment operations
 * 
 * Provides functionality to:
 * - Start MFA enrollment process
 * - Verify and complete MFA enrollment
 * - Remove MFA from user accounts
 * 
 * @returns MFA enrollment functions
 */
export function useMfaEnrollment() {
  const { enrollMfa } = useMfaEnrollmentOperations();
  const { verifyMfaEnrollment } = useMfaEnrollmentVerification();
  const { unenrollMfa } = useMfaUnenrollment();

  return {
    enrollMfa,
    verifyMfaEnrollment,
    unenrollMfa
  };
}
